'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var lodash = require('lodash');
var reactRedux = require('react-redux');
var classNames = require('classnames');
var text$1 = require('@piconetworks/text');
var produce = require('immer');
var effects = require('redux-saga/effects');
var axios = require('axios');
var Marked = require('marked');
var DOMPurify = require('dompurify');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var produce__default = /*#__PURE__*/_interopDefaultLegacy(produce);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var Marked__default = /*#__PURE__*/_interopDefaultLegacy(Marked);
var DOMPurify__default = /*#__PURE__*/_interopDefaultLegacy(DOMPurify);

var selectors = {
  isFetchingMarkdown: function isFetchingMarkdown() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        text = _ref.text;

    return text === null || text === void 0 ? void 0 : text.isFetchingMarkdown;
  },
  markdownFiles: function markdownFiles() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        text = _ref2.text;

    return text === null || text === void 0 ? void 0 : text.markdownFiles;
  },
  isFetchingJson: function isFetchingJson() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        text = _ref3.text;

    return text === null || text === void 0 ? void 0 : text.isFetchingJson;
  },
  jsonFiles: function jsonFiles() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        text = _ref4.text;

    return text === null || text === void 0 ? void 0 : text.jsonFiles;
  },
  getMarkdownFile: function getMarkdownFile(state, url) {
    var markdownFiles = selectors.markdownFiles(state);

    if (!url) {
      return null;
    }

    return markdownFiles[url];
  },
  getJsonFile: function getJsonFile(state, url) {
    var jsonFiles = selectors.jsonFiles(state);

    if (!url) {
      return null;
    }

    return jsonFiles[url];
  }
};

var actionCreatorFactory = function actionCreatorFactory(type) {
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        payload = _ref.payload,
        error = _ref.error;

    return Object.assign({
      type: type
    }, payload && {
      payload: payload
    }, error && {
      error: error
    });
  };
};

var types = {
  FETCH_MARKDOWN: 'FETCH_MARKDOWN',
  FETCH_MARKDOWN_SUCCESS: 'FETCH_MARKDOWN_SUCCESS',
  FETCH_MARKDOWN_ERROR: 'FETCH_MARKDOWN_ERROR',
  FETCH_JSON: 'FETCH_JSON',
  FETCH_JSON_SUCCESS: 'FETCH_JSON_SUCCESS',
  FETCH_JSON_ERROR: 'FETCH_JSON_ERROR'
};
var creators = {
  fetchMarkdown: actionCreatorFactory(types.FETCH_MARKDOWN),
  fetchMarkdownSuccess: actionCreatorFactory(types.FETCH_MARKDOWN_SUCCESS),
  fetchMarkdownError: actionCreatorFactory(types.FETCH_MARKDOWN_ERROR),
  fetchJson: actionCreatorFactory(types.FETCH_JSON),
  fetchJsonSuccess: actionCreatorFactory(types.FETCH_JSON_SUCCESS),
  fetchJsonError: actionCreatorFactory(types.FETCH_JSON_ERROR)
};

var styles = {"container":"RemoteMarkdown-module_container__1aO8-"};

/* eslint-disable react/no-danger */

var RemoteMarkdown = function RemoteMarkdown(_ref) {
  var url = _ref.url,
      options = _ref.options,
      onClickLink = _ref.onClickLink,
      _ref$linkColor = _ref.linkColor,
      linkColor = _ref$linkColor === void 0 ? '' : _ref$linkColor;
  var dispatch = reactRedux.useDispatch();
  var markdownFile = reactRedux.useSelector(function (state) {
    return selectors.getMarkdownFile(state, url);
  }, lodash.isEqual);
  var isFetching = reactRedux.useSelector(function (state) {
    return selectors.isFetchingMarkdown(state, url);
  }, lodash.isEqual);
  React.useEffect(function () {
    if (url && !markdownFile && !(markdownFile !== null && markdownFile !== void 0 && markdownFile.error) && !isFetching) {
      dispatch(creators.fetchMarkdown({
        payload: {
          url: url,
          options: options
        }
      }));
    }
  }, [dispatch, url, options, isFetching]);

  if (!markdownFile || markdownFile.error || !markdownFile.html) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles.container,
    style: {
      '--data-color': linkColor
    },
    dangerouslySetInnerHTML: {
      __html: markdownFile.html
    },
    onClick: function onClick(event) {
      var _event$target;

      event.stopPropagation();
      event.preventDefault();
      var href = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.href;
      onClickLink(href);
    }
  });
};

RemoteMarkdown.defaultProps = {
  onClickLink: function onClickLink() {},
  options: {}
};
RemoteMarkdown.propTypes = {
  url: PropTypes__default['default'].string.isRequired,
  onClickLink: PropTypes__default['default'].func,
  options: PropTypes__default['default'].object,
  linkColor: PropTypes__default['default'].string
};

/* eslint-disable react/no-danger */

var RemoteJsonText = function RemoteJsonText(_ref) {
  var url = _ref.url,
      linkColor = _ref.linkColor,
      style = _ref.style;
  var dispatch = reactRedux.useDispatch();
  var json = reactRedux.useSelector(function (state) {
    return selectors.getJsonFile(state, url);
  }, lodash.isEqual);
  var isFetching = reactRedux.useSelector(function (state) {
    return selectors.isFetchingJson(state, url);
  }, lodash.isEqual);
  React.useEffect(function () {
    if (!isFetching && url && !json && !(json !== null && json !== void 0 && json.error)) {
      dispatch(creators.fetchJson({
        payload: {
          url: url
        }
      }));
    }
  }, [isFetching, JSON.stringify(json)]);

  if (!json || json !== null && json !== void 0 && json.error) {
    return null;
  }

  var _ref2 = json || {},
      _ref2$description = _ref2.description,
      description = _ref2$description === void 0 ? '' : _ref2$description,
      _ref2$feature_list = _ref2.feature_list,
      featureList = _ref2$feature_list === void 0 ? [] : _ref2$feature_list;

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, description && /*#__PURE__*/React__default['default'].createElement(text$1.P, null, description), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: style.list
  }, featureList.map(function (item, i) {
    return /*#__PURE__*/React__default['default'].createElement("li", {
      key: i
    }, /*#__PURE__*/React__default['default'].createElement("i", {
      className: classNames__default['default'](style.icon, 'icon-icon_checkmark'),
      style: {
        color: linkColor
      }
    }), item.label, item.detail && /*#__PURE__*/React__default['default'].createElement("span", null, item.detail));
  })));
};

RemoteJsonText.defaultProps = {// options: {},
};
RemoteJsonText.propTypes = {
  url: PropTypes__default['default'].string.isRequired,
  linkColor: PropTypes__default['default'].any.isRequired,
  style: PropTypes__default['default'].any.isRequired
};
var RemoteJsonText$1 = React__default['default'].memo(RemoteJsonText);

var initialState = {
  isFetchingMarkdown: null,
  markdownFiles: {},
  isFetchingJson: null,
  jsonFiles: {}
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload,
      error = _ref.error;

  return produce__default['default'](state, function (draftState) {
    switch (type) {
      case types.FETCH_MARKDOWN:
        draftState.isFetchingMarkdown = true;
        break;

      case types.FETCH_MARKDOWN_SUCCESS:
        draftState.isFetchingMarkdown = false;
        draftState.markdownFiles[payload.url] = payload;
        break;

      case types.FETCH_MARKDOWN_ERROR:
        draftState.isFetchingMarkdown = false;
        draftState.markdownFiles[payload.url] = {
          error: error
        };
        break;

      case types.FETCH_JSON:
        draftState.isFetchingJson = true;
        break;

      case types.FETCH_JSON_SUCCESS:
        draftState.isFetchingJson = false;
        draftState.jsonFiles[payload.url] = payload.json;
        break;

      case types.FETCH_JSON_ERROR:
        draftState.isFetchingJson = false;
        draftState.jsonFiles[payload.url] = {
          error: error
        };
        break;

    }

    return undefined;
  });
};

var marked = function marked(markdownString, options) {
  return new Promise(function (resolve, reject) {
    return Marked__default['default'](markdownString, options, function (err, html) {
      if (err) {
        return reject(err);
      }

      return resolve(html);
    });
  });
};

function* fetchMarkdown(_ref) {
  var payload = _ref.payload;
  var url = payload === null || payload === void 0 ? void 0 : payload.url;
  var options = (payload === null || payload === void 0 ? void 0 : payload.options) || {};

  try {
    if (!url) {
      throw new Error('markdown url must be provided');
    }

    var response = yield effects.call(axios__default['default'], {
      method: 'get',
      timeout: 5000,
      url: url
    });

    if (!response || !response.data) {
      throw new Error('response object not returned from axios');
    }

    var html = yield effects.call(marked, response.data, options);
    var cleanHtml = DOMPurify__default['default'].sanitize(html);
    yield effects.put(yield effects.call(creators.fetchMarkdownSuccess, {
      payload: {
        url: url,
        html: cleanHtml
      }
    }));
  } catch (error) {
    yield effects.put(yield effects.call(creators.fetchMarkdownError, {
      payload: {
        url: typeof url === 'undefined' ? null : url
      },
      error: error.message
    }));
  }
}

function* fetchJson(_ref) {
  var payload = _ref.payload;
  var url = payload === null || payload === void 0 ? void 0 : payload.url;

  try {
    if (!url) {
      throw new Error('markdown url must be provided');
    }

    var response = yield effects.call(axios__default['default'], {
      method: 'get',
      timeout: 5000,
      url: url
    });

    if (!response || !response.data) {
      throw new Error('response object not returned from axios');
    }

    var json = response.data;
    yield effects.put(yield effects.call(creators.fetchJsonSuccess, {
      payload: {
        url: url,
        json: json
      }
    }));
  } catch (error) {
    yield effects.put(yield effects.call(creators.fetchJsonError, {
      payload: {
        url: typeof url === 'undefined' ? null : url
      },
      error: error.message
    }));
  }
}

var takes = [effects.takeEvery(types.FETCH_MARKDOWN, fetchMarkdown), effects.takeEvery(types.FETCH_JSON, fetchJson)];
var sagas = {
  fetchMarkdown: fetchMarkdown,
  fetchJson: fetchJson
};

var text = {
  store: 'text',
  initialState: initialState,
  reducer: reducer,
  types: types,
  creators: creators,
  sagas: sagas,
  takes: takes,
  selectors: selectors
};

exports.RemoteJsonText = RemoteJsonText$1;
exports.RemoteMarkdown = RemoteMarkdown;
exports.text = text;
